export default __webpack_public_path__ + "static/media/image matrimony1.41aa513a.jpg";